import { RothPortionEnum } from "./RothPortionEnum";

export const rothPortionOptions = [
  RothPortionEnum.none,
  RothPortionEnum.some,
  RothPortionEnum.all
];
